const vehicleSoldStageUIMapping = {
  auction: "Auction",
  BuyNow: "Auction",
  negotiation: "Negotiation"
};

export {
  vehicleSoldStageUIMapping
};
